module.exports = __webpack_public_path__ + "static/glasschale-weiß_blau.93f07752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/glasschale-weiß_blau.jpg
// module id = 549
// module chunks = 35783957827783